/**
 * @deprecated Import creator types directly from eyejack-web-core:
 * `@webcore/core/creator/types`
 */
import type {
  CreatorArtwork,
  CreatorArtworkImage,
  CreatorArtworkWorld,
  CreatorCollection,
  CreatorFile,
  CreatorFileType,
  CreatorPayload,
  CreatorSceneAsset,
  CreatorSceneChild,
  CreatorSceneConfig,
  CreatorSceneRoot,
} from "@webcore/core/creator/types";
import {
  CreatorArtworkWorldTargetType,
  CreatorFileImageCoverType,
  CreatorFileImageTargetType,
  CreatorFileImageType,
  CreatorFileVideoAlphaType,
  CreatorFileVideoType,
  isCreatorArtworkImage,
  isCreatorArtworkWorld,
  isCreatorCollection,
} from "@webcore/core/creator/types";

export type ArtworkType = "imagetarget" | "worldtarget";

export type {
  CreatorFileType,
  CreatorFile,
  CreatorArtworkImage,
  CreatorArtworkWorld,
  CreatorArtwork,
  CreatorCollection,
  CreatorPayload,
};
export {
  CreatorArtworkWorldTargetType,
  CreatorFileImageCoverType,
  CreatorFileImageTargetType,
  CreatorFileImageType,
  CreatorFileVideoAlphaType,
  CreatorFileVideoType,
};

export interface MicrositeData {
  name: string;
  description: string;
  constructedCover: string;
}

export const isCollection = (payload: CreatorPayload): payload is CreatorCollection =>
  isCreatorCollection(payload);

export const isArtwork = (payload: CreatorPayload): payload is CreatorArtwork =>
  isCreatorArtworkImage(payload) || isCreatorArtworkWorld(payload);

export const getArtworkType = (artwork: CreatorArtwork): ArtworkType => {
  return artwork.type === CreatorArtworkWorldTargetType ? "worldtarget" : "imagetarget";
};

export const getArtworks = (payload: CreatorPayload): CreatorArtwork[] => {
  if (isCollection(payload)) return payload.artworks;
  if (isArtwork(payload)) return [payload];
  return [];
};

export type SceneConfigAsset = CreatorSceneAsset;
export type SceneConfigChild = CreatorSceneChild;
export type SceneConfigScene = CreatorSceneRoot;
export type SceneConfig = CreatorSceneConfig;

export interface PanelFile {
  path: string;
  width?: number;
  height?: number;
  fileID?: string | null;
  id?: string;
  type?: string;
  size?: number;
  [key: string]: unknown;
}

export interface PanelArtworkEntry {
  files?: PanelFile[];
  sceneConfig?: string | SceneConfig;
  name?: string;
  id?: string;
  [key: string]: unknown;
}